/** Parse the contract's fixed-width UTC timestamps from PocketBase. */
export function parseScrapedAt(value) {
  if (!value) return null
  const normalized = String(value).replace(' ', 'T')
  const parsed = new Date(normalized)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}
